export default __webpack_public_path__ + "static/media/doctor_image.2b9aedd3.png";